import React, { useState } from 'react';
import { AuthHeader } from '../components/AuthHeader';
import { EndpointTable } from '../components/EndpointTable';
import { SearchBar } from '../components/SearchBar';
import { Button } from '../components/Button';
import { PlusIcon, AlertTriangleIcon } from 'lucide-react';
import { EditEndpointModal } from '../components/EditEndpointModal';
import { ValidationLogsTable } from '../components/validation/ValidationLogsTable';
const initialEndpoints = [{
  id: 1,
  path: '/v1/evaluate/ACM102/iso20022/pacs.008.001.011-transfers',
  createdOn: '2023-10-15',
  lastUpdated: '2023-11-02',
  status: 'Ready for Approval',
  tenantId: 'ACM102',
  workflowStatus: 'active'
}, {
  id: 2,
  path: '/v1/evaluate/FIN345/iso8583/0200-payments',
  createdOn: '2023-11-05',
  lastUpdated: '2023-11-05',
  status: 'In-Progress',
  tenantId: 'FIN345',
  workflowStatus: 'active'
}, {
  id: 3,
  path: '/v1/evaluate/BNK123/iso20022/pacs.002.001.011-transfers',
  createdOn: '2023-08-30',
  lastUpdated: '2023-10-28',
  status: 'Ready for Approval',
  tenantId: 'BNK123',
  workflowStatus: 'active'
}, {
  id: 4,
  path: '/v1/evaluate/GLB789/iso20022/pain.013.001.010-payments',
  createdOn: '2023-07-12',
  lastUpdated: '2023-09-18',
  status: 'Ready for Approval',
  tenantId: 'GLB789',
  workflowStatus: 'active'
}, {
  id: 5,
  path: '/v1/evaluate/PAY456/iso20022/pacs.008.001.011-payments',
  createdOn: '2023-11-01',
  lastUpdated: '2023-11-01',
  status: 'Suspended',
  tenantId: 'PAY456',
  workflowStatus: 'active'
}, {
  id: 6,
  path: '/v2/evaluate/ACM102/iso20022/pacs.008.001.011-transfers',
  createdOn: '2023-11-12',
  lastUpdated: '2023-11-12',
  status: 'Cloned',
  tenantId: 'ACM102',
  workflowStatus: 'active'
}] as const;
export const DEMSModule: React.FC = () => {
  const [endpoints, setEndpoints] = useState(initialEndpoints);
  const [searchTerm, setSearchTerm] = useState('');
  const [editingEndpointId, setEditingEndpointId] = useState<number | null>(null);
  const [showValidationLogs, setShowValidationLogs] = useState(false);
  const filteredEndpoints = endpoints.filter(endpoint => endpoint.path.toLowerCase().includes(searchTerm.toLowerCase()));
  const handleDelete = (id: number) => {
    setEndpoints(endpoints.filter(endpoint => endpoint.id !== id));
  };
  const handleEdit = (id: number) => {
    setEditingEndpointId(id);
  };
  const handleAddNew = () => {
    setEditingEndpointId(-1);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-1207">
      <AuthHeader title="Dynamic Endpoint Monitoring Service" showBackButton={true} data-id="element-1208" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-1209">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4" data-id="element-1210">
          <div className="flex items-center space-x-4" data-id="element-1211">
            <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} placeholder="Search endpoints..." data-id="element-1212" />
            <Button variant="secondary" onClick={() => setShowValidationLogs(!showValidationLogs)} icon={<AlertTriangleIcon size={16} data-id="element-1214" />} data-id="element-1213">
              Validation Logs
            </Button>
          </div>
          <Button onClick={handleAddNew} icon={<PlusIcon size={16} data-id="element-1216" />} data-id="element-1215">
            Create New Connection
          </Button>
        </div>
        {showValidationLogs ? <ValidationLogsTable data-id="element-1217" /> : <EndpointTable endpoints={filteredEndpoints} onEdit={handleEdit} onDelete={handleDelete} data-id="element-1218" />}
      </div>
      <EditEndpointModal isOpen={editingEndpointId !== null} onClose={() => setEditingEndpointId(null)} endpointId={editingEndpointId!} data-id="element-1219" />
    </div>;
};